// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';
import config from '../../config';

// export const CoursesContext = createContext();

// export const CoursesProvider = ({ children }) => {
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchCourses = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${config.backendUrl}/api/courses`);
//       if (response.data.success) {
//         setCourses(response.data.courses);
//       } else {
//         setError('Failed to fetch courses');
//       }
//     } catch (err) {
//       setError(err.message || 'Error fetching courses');
//       console.error('Error fetching courses:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCourses();
//   }, []);

//   // Function to get course by courseName
//   const getCourseByName = (courseName) => {
//     return courses.find(course => course.courseName === courseName);
//   };

//   // Function to get course by courseid
//   const getCourseById = (courseId) => {
//     return courses.find(course => course.courseid === courseId);
//   };

//   // Function to filter courses by type
//   const getCoursesByMode = (mode) => {
//     if (!mode) return courses.filter(course => !course.mode);
//     return courses.filter(course => course.mode === mode);
//   };

//   // Function to get video lecture courses
//   const getVideoLectureCourses = () => {
//     return courses.filter(course => course.mode === 'Video Lectures');
//   };

//   // Function to get live class courses
//   const getLiveClassCourses = () => {
//     return courses.filter(course => !course.mode || course.mode === 'online');
//   };

//   return (
//     <CoursesContext.Provider value={{
//       courses,
//       loading,
//       error,
//       fetchCourses,
//       getCourseByName,
//       getCourseById,
//       getCoursesByMode,
//       getVideoLectureCourses,
//       getLiveClassCourses
//     }}>
//       {children}
//     </CoursesContext.Provider>
//   );
// };



import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const CoursesContext = createContext();

export const CoursesProvider = ({ children }) => {
  const [courses, setCourses] = useState([]);
  const [internships, setInternships] = useState([]);
  const [workshops, setWorkshops] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${config.backendUrl}/api/courses`);

      if (response.data.success) {
        const apiCourses = response.data.courses || [];
        setCourses(apiCourses);

        let rawInternships;
        if (response.data.internshipProgram?.data) {
          rawInternships = response.data.internshipProgram.data;
        } else if (response.data.internships) {
          rawInternships = response.data.internships;
        } else if (Array.isArray(response.data.internshipProgram)) {
          rawInternships = response.data.internshipProgram;
        } else {
          rawInternships = apiCourses.filter((course) =>
            `${course.path || ''} ${course.title || ''} ${course.coursename || course.courseName || ''}`
              .toLowerCase()
              .includes('internship')
          );
        }

        const normalizedInternships = rawInternships.map((item) => {
          const startDate =
            item.startDate ?? item.start_date ?? item.startdate ?? null;
          const image =
            (item.image && item.image !== "null" ? item.image : null) ??
            (item.image_url && item.image_url !== "null" ? item.image_url : null);
          const courseName =
            item.courseName ?? item.coursename ?? item.course_name ?? "";
          const courseid = item.courseid ?? item.course_id ?? item.id ?? "";
          const time = item.time ?? item.start_time ?? item["time"] ?? null;

          return {
            ...item,
            courseid,
            courseName,
            title: item.title || courseName,
            startDate,
            time,
            duration: item.duration,
            image,
            mode: item.mode,
            path: item.path,
            price: item.price ?? item.actual_price ?? item.mrp ?? null,
            offer_price: item.offer_price ?? item.offerPrice ?? item.discounted_price ?? null,
            discount:
              item.discount ?? item.discountPercent ?? item.discount_percentage ?? 0,
          };
        });
        setInternships(normalizedInternships);

        // Preserve workshops as-is
        setWorkshops(response.data.workshopProgram?.data || []);
      } else {
        setError('Failed to fetch courses');
      }

    } catch (err) {
      setError(err.message || 'Error fetching courses');
      console.error('Error fetching courses:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  // -------------------------------
  // Helper Functions
  // -------------------------------

  const getCourseByName = (courseName) =>
    courses.find(course => course.courseName === courseName);

  const getCourseById = (courseId) =>
    courses.find(course => course.courseid === courseId);

  const getCoursesByMode = (mode) => {
    if (!mode) return courses.filter(course => !course.mode);
    return courses.filter(course => course.mode === mode);
  };

  const getVideoLectureCourses = () =>
    courses.filter(course => course.mode === 'Video Lectures');

  const getLiveClassCourses = () =>
    courses.filter(course => !course.mode || course.mode === 'online');

  return (
    <CoursesContext.Provider
      value={{
        courses,
        internships,
        workshops,
        loading,
        error,
        fetchCourses,
        getCourseByName,
        getCourseById,
        getCoursesByMode,
        getVideoLectureCourses,
        getLiveClassCourses
      }}
    >
      {children}
    </CoursesContext.Provider>
  );
};
